import classNames from "classnames";
import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

type TimelineRootNode = HTMLOListElement;

interface TimelineProps extends React.HTMLAttributes<TimelineRootNode> {}

const Timeline = forwardRef<TimelineRootNode, TimelineProps>(({ className, ...props }, ref) => {
  return (
    <ol
      className={twMerge(
        classNames("relative flex border-spacing-2 flex-col gap-4 border-l-4 border-vpBlue-200", className)
      )}
      ref={ref}
      {...props}
    />
  );
});

Timeline.displayName = Timeline.name;

export default Timeline;
